(ns ui.view.transaction-process.components.attachment-row
  (:require
   [clojure.string :as string]
   [common.localization :refer [tr]]
   [frontend.actions.attachment :as attachment-actions]
   [frontend.logging :as logging]
   [frontend.utils :as fu]
   [oops.core :as oops]
   [ui.components.button.view :as button]
   [ui.util :as uu]))

(defn- file-icon-class
  [content-type]
  (let [image? (some-> content-type (string/starts-with? "image"))
        pdf?   (= content-type "application/pdf")]
    (cond image? "fal fa-image"
          pdf?   "fal fa-file-pdf"
          :else  "fal fa-file")))

(defn- delete-confirmation-dialog
  [{:keys [set-ref on-confirm on-close]}]
  [:dialog
   {:ref set-ref
    :class "rounded border p-0"}
   [:div {:class "flex flex-col items-center gap-5 p-4 pt-8 w-96"}
    [:i {:class "fal fa-exclamation-triangle text-3xl text-danger-regular"}]
    [:div
     [:p {:class "text-center text-lg font-medium mb-2"} (tr :remove-file?)]
     [:p {:class "text-center text-sm m-0 text-base-light-text-paler"}
      (tr :attachment-delete)]]
    [:div {:class "flex gap-1 justify-center"}
     [button/sm-secondary-hollow {:on-click on-close} (tr :cancel)]
     [button/sm-danger-solid
      {:on-click (fn []
                   (on-confirm)
                   (on-close))}
      (tr :remove)]]]])

(defn view
  [_]
  (let [dialog-ref   (atom nil)
        open-dialog  #(some-> @dialog-ref (oops/ocall "showModal"))
        close-dialog #(some-> @dialog-ref (oops/ocall "close"))]
    (fn [{:keys [attachment target-id read-only?]}]
      (let [att-id       (:db/id attachment)
            filename     (:attachment/filename attachment)
            content-type (:attachment/content-type attachment)
            delete!      (fn []
                           (attachment-actions/*<-remove-attachment
                            {:target-id target-id :attachment-id att-id}
                            (fn [_] nil)
                            (fn [err] (logging/error "Delete attachment failed" err))))]
        [:div {:class "group/att flex items-center gap-3 py-1.5 px-2 rounded hover:bg-gray-50"}
         [:button {:class    "flex items-center gap-2 p-0 text-sm m-0 text-gray-700 hover:text-gray-900"
                   :on-click #(fu/open-attachment! att-id)}
          [:i {:class (uu/cm "text-gray-400" (file-icon-class content-type))}]
          [:span filename]]
         [:div {:class "flex items-center gap-1 opacity-0 group-hover/att:opacity-100"}
          [button/square-secondary-open
           {:tooltip  (tr :open)
            :on-click #(fu/open-attachment! att-id)}
           [:i {:class "fal fa-external-link"}]]
          [button/square-secondary-open
           {:tooltip  (tr :download)
            :on-click #(fu/download-attachment! att-id)}
           [:i {:class "fal fa-cloud-download"}]]
          (when-not read-only?
            [button/square-secondary-open
             {:tooltip  (tr :delete)
              :on-click open-dialog}
             [:i {:class "fal fa-trash"}]])]
         (when-not read-only?
           [delete-confirmation-dialog
            {:set-ref    #(reset! dialog-ref %)
             :on-confirm delete!
             :on-close   close-dialog}])]))))
